export const cardCancellation = {
    usePrepaidCancellationFlow: false,
};
